import { render, staticRenderFns } from "./AutoNombreDNINroAfiOspetax.vue?vue&type=template&id=bf14e4ae&"
import script from "./AutoNombreDNINroAfiOspetax.vue?vue&type=script&lang=js&"
export * from "./AutoNombreDNINroAfiOspetax.vue?vue&type=script&lang=js&"
import style0 from "./AutoNombreDNINroAfiOspetax.vue?vue&type=style&index=0&id=bf14e4ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItemContent,VListItemSubtitle,VListItemTitle})
